<template>
  <div>
    <div class="columns">
      <div class="column">
        <b-tooltip type="is-dark" position="is-right" :label="$translate('copy_dx_in_sx') | capitalize" multilined>
          <a class="button is-primary" :disabled="leftDisabled" @click="copyToOtherFoot('right')">
            <b-icon icon="content-copy" />
          </a>
        </b-tooltip>
        <h3 class="subtitle green is-inline-block" style="margin-left: 1rem">
          {{ $translate('insole_sx') | uppercase }}
        </h3>
      </div>
      <div class="column has-text-right">
        <h3 class="subtitle green is-inline-block" style="margin-right: 1rem">
          {{ $translate('insole_dx') | uppercase }}
        </h3>
        <b-tooltip type="is-dark" position="is-left" :label="$translate('copy_sx_in_dx') | capitalize" multilined>
          <a class="button is-primary" :disabled="rightDisabled" @click="copyToOtherFoot('left')">
            <b-icon icon="content-copy" />
          </a>
        </b-tooltip>
      </div>
    </div>
    <div class="columns is-centered">
      <div class="column is-narrow">
        <table class="bordered-table dynamic measurements-insole-table">
          <tbody>
            <tr v-for="field in tableFields" :key="field.key">
              <td>
                <b-field
                  :message="errors.first(`left-${field.key}`)"
                  :type="{ 'is-danger': errors.has(`left-${field.key}`) }"
                >
                  <b-input
                    v-validate="validationFor(field, 'left')"
                    :value="order.footmeasurements[`${field.key}_sx`]"
                    :name="`left-${field.key}`"
                    type="number"
                    :placeholder="$translate('placeholder_measure_mm')"
                    :min="field.min"
                    :max="field.max"
                    :disabled="leftDisabled"
                    :use-html5-validation="false"
                    @input="val => onChange(val, 'sx', field.key)"
                  />
                </b-field>
              </td>
              <td class="header">
                <strong>{{ $translate(field.key) | capitalize }}</strong>
              </td>
              <td>
                <b-field
                  :message="errors.first(`right-${field.key}`)"
                  :type="{ 'is-danger': errors.has(`right-${field.key}`) }"
                >
                  <b-input
                    v-validate="validationFor(field, 'right')"
                    :value="order.footmeasurements[`${field.key}_dx`]"
                    :name="`right-${field.key}`"
                    type="number"
                    :placeholder="$translate('placeholder_measure_mm')"
                    :min="field.min"
                    :max="field.max"
                    :disabled="rightDisabled"
                    :use-html5-validation="false"
                    @input="val => onChange(val, 'dx', field.key)"
                  />
                </b-field>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MeasurementsInsole',
  props: ['order', 'tableFields', 'disabledbool'],
  inject: ['$validator'],
  computed: {
    leftDisabled() {
      return this.disabledbool || this.order.pair === 'right'
    },
    rightDisabled() {
      return this.disabledbool || this.order.pair === 'left'
    },
  },
  methods: {
    validationFor(field, side) {
      const disabled = side === 'left' ? this.leftDisabled : this.rightDisabled
      const rules = []
      if (field.required && !disabled) {
        rules.push('required')
      }
      if (field.min != null && field.max != null) {
        rules.push(`between:${field.min},${field.max}`)
      } else {
        rules.push('between:0,999')
      }
      rules.push('integer')
      return rules.join('|')
    },
    onChange(val, side, key) {
      this.$set(this.order.footmeasurements, `${key}_${side}`, val)
    },
    copyToOtherFoot(sourceFoot) {
      const from = sourceFoot === 'left' ? 'sx' : 'dx'
      const to = sourceFoot === 'left' ? 'dx' : 'sx'
      this.tableFields.forEach(field => {
        let value = this.order.footmeasurements[`${field.key}_${from}`]
        if (value === undefined) value = null
        this.$set(this.order.footmeasurements, `${field.key}_${to}`, value)
      })
    },
  },
}
</script>
<style scoped>
.measurements-insole-table td:first-child,
.measurements-insole-table td:last-child {
  width: 220px;
  min-width: 220px;
}
.measurements-insole-table >>> td input {
  text-align: center;
  width: 100%;
}
</style>
